import { UserTypes } from './common.model';

export interface IAccessToken {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: string;
}

export interface IAuthState {
  tokenData: IAccessToken | null;
  logoutIdToken: string | null;
  refreshTokenExpires: string | null;
}

export interface ILogoutOptions {
  withMessage?: 'idleLogoutMessage',
  userType?: UserTypes,
}

export interface ILogoutInput {
  idToken?: string,
  displayErrorOnRedirectBack?: UserTypes
  idleLogoutMessage?: boolean
  userType?: UserTypes,
}

export enum ELoginDeviceType {
  WEB = 'web',
  MOBILE = 'mobile',
}

export interface IRefreshResult {
  success: boolean;
  tokenData?: IAccessToken;
  error?: unknown;
}
